import React, { useState } from "react";
import { StyledDefaultButtonLink } from "../../../styles/pages/AcademicActivityPlanStyles";
import {
    CloseIcon,
    ArrowRightIcon,
    CheckIcon,
} from "../../../components/Icons";
import { StyledFlexDiv } from "../../../styles/MainStyles";
import ModalInformationContainer from "./Information/ModalInformationContainer";
import ModalCancelContainer from "./Information/ModalCancelContainer";
import { TermoHistorico } from "../../../context/interfaces/IAdministratorTachContext";
import StatusPill from "./StatusPill/StatusPill";
import { StatusSubprocess } from "../../../model/Enums/StatusSubprocessEnum";
import { useAdministratorTach } from "../../../context/AdministratorTachContext";
import DialogMessage from "../../../components/DialogMessage";

interface ICardListContent {
    historyTerm: TermoHistorico[];
    subprocessId: string;
    status: string;
    name: string;
    matriculaAdp: string;
}

interface IModalInformation {
    showInformation: boolean;
    showJustification: boolean;
}

const CardListContent: React.FC<ICardListContent> = ({
    historyTerm,
    subprocessId,
    status,
    name,
    matriculaAdp,
}) => {
    const [modalInformation, setModalInformation] = useState<IModalInformation>(
        {} as IModalInformation
    );
    const [modalCancel, setModalCancel] = useState<boolean>(false);
    const [dacWithoutPermission, setDacWithoutPermission] =
        useState<boolean>(false);
    const { dacPermission } = useAdministratorTach();

    const handleClick = (next: () => void) => {
        if (dacPermission.hasPermission) {
            next();
        } else {
            setDacWithoutPermission(true);
        }
    };

    return (
        <StyledFlexDiv style={{ gap: 15 }}>
            <StatusPill status={status} />
            {status === StatusSubprocess.PENDING && (
                <StyledDefaultButtonLink
                    variant="link"
                    onClick={() => handleClick(() => setModalCancel(true))}
                >
                    <CloseIcon style={{ fill: "#8A0538" }} />
                    Cancelar
                </StyledDefaultButtonLink>
            )}
            <StyledDefaultButtonLink
                variant="link"
                onClick={() => {
                    setModalInformation({
                        showInformation: true,
                        showJustification: false,
                    });
                }}
            >
                <ArrowRightIcon style={{ fill: "#8A0538" }} />
                Consultar informações
            </StyledDefaultButtonLink>
            {status === StatusSubprocess.PENDING && (
                <StyledDefaultButtonLink
                    variant="link"
                    style={{
                        borderRadius: "24px",
                        border: "1px solid #8A0538",
                        padding: "10px 24px",
                    }}
                    onClick={() =>
                        handleClick(() =>
                            setModalInformation({
                                showInformation: true,
                                showJustification: true,
                            })
                        )
                    }
                >
                    <CheckIcon style={{ fill: "#8A0538" }} />
                    Justificar
                </StyledDefaultButtonLink>
            )}
            {modalInformation.showInformation && (
                <ModalInformationContainer
                    isOpen={modalInformation.showInformation}
                    onHide={() => setModalInformation({} as IModalInformation)}
                    justify={modalInformation.showJustification}
                    subprocessId={subprocessId}
                    status={status}
                    historyTerm={historyTerm}
                    name={name}
                    matriculaAdp={matriculaAdp}
                />
            )}
            {modalCancel && (
                <ModalCancelContainer
                    isOpen={modalCancel}
                    onHide={() => setModalCancel(false)}
                    subprocessId={subprocessId}
                />
            )}
            {dacWithoutPermission && !dacPermission.hasPermission && (
                <DialogMessage
                    type="error"
                    show
                    title={dacPermission.title}
                    text={dacPermission.message}
                    onClose={() => setDacWithoutPermission(false)}
                />
            )}
        </StyledFlexDiv>
    );
};

export default CardListContent;
